import { api } from '../../../../../services/api'

export const valorService = {
  async buscarValorProduto(quantidade, idImpressao) {
    try {
      const response = await api.get('/site/v2/tercerizado/busca-valor-produto-tercerizado', {
        params: {
          quantidade: quantidade,
          id_impressao: idImpressao,
        },
      })
      return response.data
    } catch (error) {
      console.error('Erro ao buscar valor do produto:', error)
      return { valor_unitario: 0, sub_total: 0 }
    }
  },
}
